import {
  useGetSensorRollupByTypeDays as useGetSensorRollupByDaysCommon,
  SensorReadingBase,
  SensorType,
} from "common";

import { useAppSync } from "../../contexts/AppSyncContext";

export const useGetSensorRollupByType = <T extends SensorReadingBase>(
  sensorType: SensorType,
  days: number = 7,
) => {
  const { sensors, sensorsLoading, selectedHub } = useAppSync();
  return useGetSensorRollupByDaysCommon<T>(sensorType, days, {
    sensors,
    selectedHubId: selectedHub?.id,
    sensorsLoading,
  });
};
